import React from "react";
import { Link } from 'react-router-dom';
import { Container } from "react-bootstrap";

function AdminFooter() {
	return (
		<>
			<footer className="footer">
				<Container fluid className="pl-4 ml-2">
					<nav>
						<p className="copyright text-center"> © {new Date().getFullYear()} <Link to="/">All Rights Reserved by The AIDS Institute</Link></p>
					</nav>
				</Container>
			</footer>
		</>
	);
}

export default AdminFooter;
